import ExternalUtils from "./externalServiceUtils.js";

export class MessageBrokerUtils {
  static publish = async ({ channel, topic, headers, data }) => {
    const topicToPublish = await ExternalUtils.UCSDKService.getTopicAsync(
      channel,
      topic
    );

    if (topicToPublish) {
      topicToPublish.publish(headers, data);
    } else {
      console.error(
        `[MessageBrokerUtils] - MISSING CHANNEL/TOPIC (C: ${channel}, T: ${topic}))`
      );
    }
  };

  static execute = async ({ channel, topic, headers, data }) => {
    const topicToExecute = await ExternalUtils.UCSDKService.getTopicAsync(
      channel,
      topic
    );

    if (topicToExecute) {
      // Return the promise so callers can await the resolver's response.
      return topicToExecute.execute(data, headers);
    } else {
      console.error(
        `[MessageBrokerUtils] - MISSING CHANNEL/TOPIC (C: ${channel}, T: ${topic}))`
      );
    }
  };

  static subscribe = ({ channel, topic, callback }) => {
    if (window.libraryManager?.UCSDKLibrary.isReady) {
      return _subscribeWhenSDKAlreadyLoaded({ channel, topic, callback });
    }

    const subscriptionReadyPromise = (async () => {
      await window.libraryManager?.UCSDKLibrary.ready;
      return _subscribeWhenSDKAlreadyLoaded({ channel, topic, callback });
    })();

    return {
      unsubscribe: async () => {
        const sub = await subscriptionReadyPromise;
        sub?.unsubscribe();
      }
    };
  };

  static registerResolver = ({ channel, action, callback }) => {
    if (window.libraryManager?.UCSDKLibrary.isReady) {
      return _registerResolverWhenSDKAlreadyLoaded({
        channel,
        action,
        callback
      });
    }

    // If the SDK is not ready, wait for it to be ready before registering the resolver
    return (async () => {
      await window.libraryManager?.UCSDKLibrary.ready;
      return _registerResolverWhenSDKAlreadyLoaded({
        channel,
        action,
        callback
      });
    })();
  };

  static publishSync = ({ channel, topic, headers, data }) => {
    const topicToPublish = ExternalUtils.UCSDKService.getTopic(channel, topic);

    if (topicToPublish) {
      topicToPublish.publish(headers, data);
    } else {
      console.error(
        `[MessageBrokerUtils] - MISSING CHANNEL/TOPIC (C: ${channel}, T: ${topic}))`
      );
    }
  };

  static subscribeSync = ({ channel, topic, callback }) => {
    const topicToSubscribe = ExternalUtils.UCSDKService.getTopic(
      channel,
      topic
    );

    if (topicToSubscribe) {
      return topicToSubscribe.subscribe(callback);
    } else {
      console.error(
        `[MessageBrokerUtils] - MISSING CHANNEL/TOPIC (C: ${channel}, T: ${topic}))`
      );
    }

    return null;
  };
}

const _subscribeWhenSDKAlreadyLoaded = ({ channel, topic, callback }) => {
  const topicToSubscribe = ExternalUtils.UCSDKService.getTopic(channel, topic);

  if (topicToSubscribe) {
    return topicToSubscribe.subscribe((...params) => callback(...params));
  } else {
    console.error(
      `[MessageBrokerUtils] - MISSING CHANNEL/TOPIC (C: ${channel}, T: ${topic}))`
    );
  }
};

const _registerResolverWhenSDKAlreadyLoaded = ({
  channel,
  action,
  callback
}) => {
  const actionToRegisterResolver = ExternalUtils.UCSDKService.getTopic(
    channel,
    action
  );

  if (actionToRegisterResolver) {
    return actionToRegisterResolver.registerResolver((...params) =>
      callback(...params)
    );
  } else {
    console.error(
      `[MessageBrokerUtils] - MISSING CHANNEL/ACTION (C: ${channel}, T: ${action}))`
    );
  }
};
